import 'css-chunksrc/client/scenes/chatbot/conversationSidebar/styles.scss';export default {
  "conversationSidebar": "_conversationSidebar_1cpd9_1",
  "logoBox": "_logoBox_1cpd9_12",
  "logo": "_logo_1cpd9_12",
  "header": "_header_1cpd9_23",
  "title": "_title_1cpd9_30",
  "historyIcon": "_historyIcon_1cpd9_39",
  "newButton": "_newButton_1cpd9_45",
  "icon": "_icon_1cpd9_57",
  "scrollPane": "_scrollPane_1cpd9_63",
  "list": "_list_1cpd9_67",
  "placeholder": "_placeholder_1cpd9_73",
  "conversation": "_conversation_1cpd9_1",
  "selected": "_selected_1cpd9_92",
  "contextualMenu": "_contextualMenu_1cpd9_95",
  "conversationTitle": "_conversationTitle_1cpd9_99"
};